import { render, staticRenderFns } from "./PhaseData.vue?vue&type=template&id=b146df3e&"
import script from "./PhaseData.vue?vue&type=script&lang=js&"
export * from "./PhaseData.vue?vue&type=script&lang=js&"
import style0 from "./PhaseData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports